import { useContext } from 'react';
import { AccessTokenContext } from 'providers/AccessTokenProvider'

function useAuth() {
  const { accessToken, setAccessToken, decoded } = useContext(AccessTokenContext)

  return { accessToken, setAccessToken, decoded }; 
}

export default useAuth;